import { atom } from 'jotai'
import type { RecipientType } from './useRecipientsSelection'

export const recipientTypesAtom = atom<{
  contactTypes: Record<string, RecipientType>
  setType: (contactId: string, type: RecipientType) => void
  disabled: boolean
}>({
  contactTypes: {},
  setType: () => {},
  disabled: false
})
